import {Injectable, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from '../login/login.component';
import {ActivatedRouteSnapshot, Resolve, RouterModule, RouterStateSnapshot, Routes} from '@angular/router';
import {LayoutComponent} from '../layout/layout.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {UsersComponent} from './users/users.component';
import {NewUserComponent} from './users/new-user/new-user.component';
import {PeopleComponent} from './people/people.component';
import {SurveysComponent} from './surveys/surveys.component';
import {WorkshopsComponent} from './workshops/workshops.component';
import {BrowserModule} from '@angular/platform-browser';
import {HeaderComponent} from '../header/header.component';
import {SideMenuComponent} from '../side-menu/side-menu.component';
import {NewSurveyComponent} from './surveys/new-survey/new-survey.component';
import {DefineTabComponent} from './surveys/new-survey/define-tab/define-tab.component';
import {IntroTabComponent} from './surveys/new-survey/intro-tab/intro-tab.component';
import {PeopleTabComponent} from './surveys/new-survey/people-tab/people-tab.component';
import {ReviewTabComponent} from './surveys/new-survey/review-tab/review-tab.component';
import {QuestionsTabComponent} from './surveys/new-survey/questions-tab/questions-tab.component';
import {InfoPopupComponent} from './surveys/new-survey/info-popup/info-popup.component';
import {SurveyComponent} from './surveys/survey/survey.component';
import {MasterSummaryComponent} from './surveys/master-summary/master-summary.component';
import {AnalysisComponent} from './surveys/analysis/analysis.component';
import {ReportSummaryComponent} from './surveys/report-summary/report-summary.component';
import {PaymentsComponent} from './surveys/payments/payments.component';
import {NewReportComponent} from './surveys/new-report/new-report.component';
import {FooterComponent} from '../footer/footer.component';
import {NgDatepickerModule} from 'ng2-datepicker';
import {AddLanguageComponent} from './surveys/new-survey/questions-tab/add-language/add-language.component';
import {DropdownComponent} from '../shared/components/dropdown/dropdown.component';
import {LoaderComponent} from '../shared/components/loader/loader.component';
import {PopoverComponent} from '../shared/components/popover/popover.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CreateTabComponent} from './surveys/new-survey/create-tab/create-tab.component';
import {ForgotComponent} from '../forgot/forgot.component';
import {AuthGuard} from '../shared/services/auth-guard.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ToasterModule} from 'angular5-toaster/dist';
import {DropdownTypeComponent} from '../shared/components/dropdown-type/dropdown-type.component';
import {
  DxAutocompleteModule,
  DxChartModule,
  DxColorBoxModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxPieChartModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTemplateModule,
  DxScrollViewModule
} from 'devextreme-angular';
import {DashboardService} from './dashboard/dashboard.service';
import {HttpRequestService} from '../shared/services/http-request.service';
import {DataTransferService} from '../shared/services/data-transfer.service';
import {EditUserComponent} from './users/edit-user/edit-user.component';
import {ClickOutsideDirective} from '../shared/directives/click-outside.directive';
import {SurveyListComponent} from './people/survey-list/survey-list.component';
import {PeopleService} from './people/people.service';
import {UsersService} from './users/users.service';
import {SurveyService} from './surveys/surveys.service';
import {PreviousUrlService} from '../shared/services/previous-url.service';
import {ConfirmPasswordComponent} from './confirm-password/confirm-password.component';
import {BarRatingModule} from 'ngx-bar-rating';
import {DndModule} from 'ng2-dnd';
import {UserPopupComponent} from '../shared/components/user-popup/user-popup.component';
import {OnlyNumberDirective} from '../shared/directives/only-number.directive';
import {TypeformComponent} from './surveys/typeform/typeform.component';
import {TypeformService} from './surveys/typeform/typeform.service';
import {TypeformErrorMessageComponent} from './surveys/typeform/typeform-error-message/typeform-error-message.component';
import {QuestionFilterComponent} from './surveys/master-summary/question-filter/question-filter.component';
import {IncludeVersionComponent} from './surveys/master-summary/include-version/include-version.component';
import {BarChartComponent} from '../shared/components/chart/bar-chart/bar-chart.component';
import {PieChartComponent} from '../shared/components/chart/pie-chart/pie-chart.component';
import {NumericChartComponent} from '../shared/components/chart/numeric-chart/numeric-chart.component';
import {MostCommonChartComponent} from '../shared/components/chart/most-common-chart/most-common-chart.component';
import {SummaryQuestionTableComponent} from '../shared/components/chart/summary-question-table/summary-question-table.component';
import {MultiChoiceDropdownComponent} from '../shared/components/multi-choice-dropdown/multi-choice-dropdown.component';
import {MultiPictureChoiceDropdownComponent} from '../shared/components/multi-picture-choice-dropdown/multi-picture-choice-dropdown.component';
import {CompareQuestionTableComponent} from './surveys/master-summary/compare-question-table/compare-question-table.component';
import {DropdownWithErrorComponent} from '../shared/components/dropdown-with-error/dropdown-with-error.component';
import {InputNumberCustomComponent} from '../shared/components/input-number-custom/input-number-custom.component';
import {InputDateCustomComponent} from '../shared/components/input-date-custom/input-date-custom.component';
import {TextCustomDropdownComponent} from '../shared/components/text-custom-dropdown/text-custom-dropdown.component';
import {CombinedVersionComponent} from './surveys/master-summary/combined-version/combined-version.component';
import {CombinedQuestionTableComponent} from './surveys/master-summary/combined-question-table/combined-question-table.component';
import {CutCreatePopupComponent} from './surveys/cut/cut-create-popup.component';
import {BoxViewVersionComponent} from './surveys/box-view-version/box-view-version.component';
import {SubMenuIconComponent} from './surveys/box-view-version/sub-menu/sub-menu-icon.component';
import {ChartingComponent} from './surveys/master-summary/charting/charting.component';
import {CutsComponent} from './surveys/cut/cuts.component';
import {CutItemComponent} from './surveys/cut/cut-item/cut-item.component';
import {CompareVersionComponent} from './surveys/master-summary/compare-version/compare-version.component';
import {HasAnyAuthorityDirective} from '../shared/directives/has-any-authority.directive';
import {DropdownCustomComponent} from '../shared/components/dropdown-custom/dropdown-custom.component';
import {UserTabComponent} from './surveys/new-survey/user-tab/user-tab.component';
import { UpdateNumberRangeComponent } from '../shared/components/input-number-custom/update-number-range-popup.component';
import {SurveyMonkeyComponent} from './surveys/survey-monkey/survey-monkey.component';
import {SurveyMonkeyService} from './surveys/survey-monkey/survey-monkey.service';
import { SurveyImportCSVComponent } from './surveys/import-csv/import-csv.component';
import { ImportCSVService } from './surveys/import-csv/import-csv.service';
import { FileUploadModule } from 'ng2-file-upload';
import { ImportTemplateService } from './surveys/import-csv/import-template.service';
import { TagCloudModule } from 'angular-tag-cloud-module';
import { WordCloudComponent } from '../shared/word-cloud/word-cloud.component';
import { WordCountTableComponent } from '../shared/components/chart/word-count-table/word-count-table.component';
import { WordCloudRawtextPopupComponent } from '../shared/components/word-cloud-rawtext-popup/word-cloud-rawtext-popup.component';
import { WordCloudSettingsComponent } from './settings/word-cloud-settings/word-cloud-settings.component';
import { WordCloudSetting } from '../models/settings/word-cloud-setting';
import { WordCloudSettingsService } from './settings/word-cloud-settings/word-cloud-settings.service';
import { ControlMessagesComponent } from '../shared/components/control-messages/control-messages.component';
import { QuestionExceptionWordsComponent } from './surveys/new-survey/questions-tab/question-exception-words/question-exception-words.component';
import { SortIconComponent } from './surveys/master-summary/icon-dropdown/sort-icon/sort-icon.component';
import { PercentageIconComponent } from './surveys/master-summary/icon-dropdown/percentage-icon/percentage-icon.component';
import { DownloadIconComponent } from './surveys/master-summary/icon-dropdown/download-icon/download-icon.component';
import { ThemeIconComponent } from './surveys/master-summary/icon-dropdown/theme-icon/theme-icon.component';
import { QuestionThemeComponent } from './surveys/new-survey/questions-tab/question-theme/question-theme.component';
import { PercentageDifferenceComponent } from './surveys/master-summary/percentage-difference/percentage-difference.component'
import { PercentageIconComponentAvgRes } from './surveys/master-summary/icon-dropdown/percentage-icon-AvgRes/percentage-icon-avgRes.component';
import { TranslateIconComponent } from './surveys/master-summary/icon-dropdown/translate-icon/translate-icon.component';
import {MailListTabComponent} from './surveys/new-survey/mail-list-tab/mail-list-tab.component';
import { SurveySettingModel, SurveyUserSettingModel } from '../models/survey-user-setting/survey-user-setting.model';
import { of } from 'rxjs/observable/of';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { DownloadAllChartsIconComponent } from './surveys/master-summary/icon-dropdown/download-all-charts-icon/download-all-charts-icon.component';
import { SmartAnalysisComponent } from './surveys/master-summary/smart-analysis/smart-analysis.component';
import { BundleTabComponent } from './surveys/new-survey/bundle-tab/bundle-tab.component';
import { BundlePopupComponent } from './surveys/new-survey/bundle-tab/bundle-popup/bundle-popup.component';
import { ClientsComponent } from './clients/clients.component';
import { ClientsService } from './clients/clients.service';
import { NewClientComponent } from './clients/new-client/new-client.component';
import { EditClientComponent } from './clients/edit-client/edit-client.component';
import { ClientModel } from '../models/survey/survey.model';
import { NgxEchartsModule } from 'ngx-echarts';
import { PieRoseChartComponent } from '../shared/components/chart/pie-rose-chart/pie-rose-chart.component';
import { HamburgerMenuIconComponent } from './surveys/cut/hamburger-menu/hamburger-menu-icon.component';
import { ParallelCoordinateChartComponent } from '../shared/components/chart/parallel-coordinate-chart/parallel-coordinate-chart.component';
import { CompareChartingComponent } from './surveys/master-summary/compare-charting/compare-charting.component';
import { ComparativeBarChartComponent } from '../shared/components/chart/comparative-bar-chart/comparative-bar-chart.component';
import { GaugeRingChartComponent } from '../shared/components/chart/gauge-ring-chart/gauge-ring-chart.component';
import { StackedBarChartComponent } from '../shared/components/chart/stacked-bar-chart/stacked-bar-chart.component';
import { HomeComponent } from '../home/home.component';
import { SignupComponent } from '../signup/signup.component';
import {ChartingService} from './surveys/charting.service';

@Injectable()
export class SurveyUserSettingResolve implements Resolve<SurveyUserSettingModel> {
    constructor(private service: SurveyService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<SurveyUserSettingModel> {
        let id = route.params['id'] ? route.params['id'] : null;
        if (id.indexOf("?") > 0) {
            id = id.substring(0, id.indexOf("?"));
        }
        if (id) {
            return this.service.getSurveyUserSetting(id);
        }
        return of(new SurveyUserSettingModel());
    }
}

@Injectable()
export class ClientResolve implements Resolve<ClientModel[]> {
    constructor(private service: UsersService) {}

    resolve(): Observable<ClientModel[]> {
        return this.service.getClient();
    }
}

@Injectable()
export class CurrentClientResolve implements Resolve<ClientModel> {
    constructor(private service: ClientsService) {}

    resolve(): Observable<ClientModel> {
        return this.service.getCurrentClient();
    }
}

const appRoutes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'login', component: LoginComponent},
  {path: 'forgot-password', component: ForgotComponent},
  {path: 'ConfirmPassword/:hash', component: ConfirmPasswordComponent},
  {path: 'signup', component: SignupComponent},
  {
    path: '', canActivate: [AuthGuard], component: LayoutComponent, children: [
      // {path: 'dashboard', canActivate: [AuthGuard], component: DashboardComponent},
      {path: 'users', resolve: {
        clients: ClientResolve
      }, canActivate: [AuthGuard], component: UsersComponent},
      {path: 'users/new', resolve: {
        clients: ClientResolve
      }, canActivate: [AuthGuard], component: NewUserComponent},
      {path: 'users/edit/:id', resolve: {
        clients: ClientResolve
      }, canActivate: [AuthGuard], component: EditUserComponent},
      // { path: 'new-user', canActivate: [AuthGuard], component: NewUserComponent},
      {path: 'people', canActivate: [AuthGuard], component: PeopleComponent},
      {path: 'surveys', resolve: {
        clients: ClientResolve,
        client: CurrentClientResolve
      }, canActivate: [AuthGuard], component: SurveysComponent},
      {path: 'surveys/survey-name', canActivate: [AuthGuard], component: SurveyComponent},
      {path: 'surveys/master-summary/:id', resolve: {
        surveyUserSetting: SurveyUserSettingResolve
      }, canActivate: [AuthGuard], component: MasterSummaryComponent},
      {path: 'surveys/report-summary/:id/:title', canActivate: [AuthGuard], component: ReportSummaryComponent},
      {path: 'surveys/analysis/:id/:rid/:title', canActivate: [AuthGuard], component: AnalysisComponent},
      {path: 'surveys/payments/:id/:title', canActivate: [AuthGuard], component: PaymentsComponent},
      {path: 'surveys/new', canActivate: [AuthGuard], component: NewSurveyComponent},
      {path: 'surveys/import-typeform', resolve: {
        client: CurrentClientResolve
      }, canActivate: [AuthGuard], component: TypeformComponent},
      {path: 'surveys/import-csv', resolve: {
        client: CurrentClientResolve
      }, canActivate: [AuthGuard], component: SurveyImportCSVComponent},
      {path: 'surveys/import-survey-monkey', resolve: {
        client: CurrentClientResolve
      }, canActivate: [AuthGuard], component: SurveyMonkeyComponent},
      {path: 'surveys/:id/cuts', canActivate: [AuthGuard], component: CutsComponent},

      {path: 'surveys/new/:id', canActivate: [AuthGuard], component: NewSurveyComponent},
      {path: 'surveys/new-report/:id/:title', canActivate: [AuthGuard], component: NewReportComponent},
      {path: 'surveys/new/:id/:title', canActivate: [AuthGuard], component: NewSurveyComponent},
      {path: 'workshops', canActivate: [AuthGuard], component: WorkshopsComponent},
      {path: 'word-cloud-settings', canActivate: [AuthGuard], component: WordCloudSettingsComponent},
      {path: 'clients', canActivate: [AuthGuard], component: ClientsComponent},
      {path: 'clients/new', canActivate: [AuthGuard], component: NewClientComponent},
      {path: 'clients/edit/:id', canActivate: [AuthGuard], component: EditClientComponent},
      {path: '**', redirectTo: 'surveys'}
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    BrowserAnimationsModule,
    NgDatepickerModule,
    DxPieChartModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxChartModule,
    FormsModule,
    BarRatingModule,
    ReactiveFormsModule,
    ToasterModule,
    DndModule.forRoot(),
    DxDateBoxModule,
    DxPopupModule,
    DxTemplateModule,
    DxAutocompleteModule,
    DxSelectBoxModule,
    FileUploadModule,
    TagCloudModule,
    DxColorBoxModule,
    NgxEchartsModule,
    DxScrollViewModule
  ],
  declarations: [
    OnlyNumberDirective,
    LoginComponent,
    LayoutComponent,
    DashboardComponent,
    NewUserComponent,
    UsersComponent,
    PeopleComponent,
    SurveysComponent,
    WorkshopsComponent,
    HeaderComponent,
    SideMenuComponent,
    NewSurveyComponent,
    DefineTabComponent,
    IntroTabComponent,
    PeopleTabComponent,
    ReviewTabComponent,
    QuestionsTabComponent,
    InfoPopupComponent,
    SurveyComponent,
    MasterSummaryComponent,
    AnalysisComponent,
    ReportSummaryComponent,
    PaymentsComponent,
    NewReportComponent,
    FooterComponent,
    AddLanguageComponent,
    DropdownComponent,
    LoaderComponent,
    PopoverComponent,
    CreateTabComponent,
    EditUserComponent,
    ClickOutsideDirective,
    SurveyListComponent,
    ConfirmPasswordComponent,
    UserPopupComponent,
    DropdownTypeComponent,
    TypeformComponent,
    TypeformErrorMessageComponent,
    QuestionFilterComponent,
    IncludeVersionComponent,
    BarChartComponent,
    PieChartComponent,
    NumericChartComponent,
    MostCommonChartComponent,
    SummaryQuestionTableComponent,
    MultiChoiceDropdownComponent,
    TextCustomDropdownComponent,
    MultiPictureChoiceDropdownComponent,
    CompareQuestionTableComponent,
    DropdownWithErrorComponent,
    InputNumberCustomComponent,
    InputDateCustomComponent,
    CombinedVersionComponent,
    CombinedQuestionTableComponent,
    BoxViewVersionComponent,
    SubMenuIconComponent,
    HamburgerMenuIconComponent,
    CutCreatePopupComponent,
    ChartingComponent,
    CutsComponent,
    CutItemComponent,
    CompareVersionComponent,
    HasAnyAuthorityDirective,
    DropdownCustomComponent,
    UserTabComponent,
    UpdateNumberRangeComponent,
    BundleTabComponent,
    BundlePopupComponent,
    MailListTabComponent,
    SurveyMonkeyComponent,
    SurveyImportCSVComponent,
    WordCloudComponent,
    WordCountTableComponent,
    WordCloudRawtextPopupComponent,
    WordCloudSettingsComponent,
    ControlMessagesComponent,
    QuestionExceptionWordsComponent,
    SortIconComponent,
    PercentageIconComponent,
    DownloadIconComponent,
    DownloadAllChartsIconComponent,
    ThemeIconComponent,
    QuestionThemeComponent,
    PercentageDifferenceComponent,
    PercentageIconComponentAvgRes,
    TranslateIconComponent,
    SmartAnalysisComponent,
    ClientsComponent,
    NewClientComponent,
    EditClientComponent,
    PieRoseChartComponent,
    CompareChartingComponent,
    ParallelCoordinateChartComponent,
    ComparativeBarChartComponent,
    GaugeRingChartComponent,
    StackedBarChartComponent,
    SignupComponent,
    HomeComponent
  ],
  providers: [
    UsersService,
    DashboardService,
    PeopleService,
    PreviousUrlService,
    HttpRequestService,
    DataTransferService,
    SurveyService,
    ChartingService,
    TypeformService,
    SurveyMonkeyService,
    ImportCSVService,
    ImportTemplateService,
    WordCloudSettingsService,
    SurveyUserSettingResolve,
    ClientsService,
    ClientResolve,
    CurrentClientResolve
  ],
  exports: [
    RouterModule,
    HasAnyAuthorityDirective
  ]
})
export class RoutesModule {
  constructor(private routerExtService: PreviousUrlService) {

  }
}



// WEBPACK FOOTER //
// ./src/app/routes/routes.module.ts